<template>
  <div id="app">
    <div id="Return_Bar">
      <i class="el-icon-arrow-left"></i>
      <div @click="isreturn" class="isreturn">返回</div>
    </div>
    <div id="text">
      <template>
        <div class="step-list" ref="asx" v-for="(c, key) in courseList" :key="key">

          <div class="step-list_top">
            <div class="list_top_left">
              <div class="circle"
                :class="{ circle: c.passState == 'Passed', othercircle: c.passState == 'Ongoing' || c.passState == null }">
                <div v-if="courseList.length != 1">{{ key + 1 }}</div>
              </div>
              {{ c.courseName }}
              <div :class="c.passState == 'Passed' ? 'isgreen' : 'isred'">
                {{ c.passState == "Passed" && c.passState != "null" ? "已完成" : "未完成" }}
              </div>

            </div>
            <div class="list_top_right">
              <div class="sp_button"  v-if="c.assitantType == 'PartnerCallOutExercise' && c.unlock == true" @click="practise(c.courseId)">练习记录</div>
              <div class="spb_button" v-if="c.assitantType == 'PartnerCallOutExercise' && step != 'handing' && c.unlock == true" @click="goDuilian(c.assitantType, c.courseId)">点击练习</div>
              <div class="sph_button" v-if="c.assitantType == 'PartnerCallOutExercise' && step == 'handing' && c.unlock == true && (curLinkCourseId == 'null' || curLinkCourseId == c.courseId)" @click="stopPrict">结束练习</div>

              <div class="sp_button" @click="testRecord(c.courseId)" v-if="c.assitantType == 'CallOutAbilityCheck' && c.unlock == true">测试记录</div>

              <div class="spb_button"
                v-if="c.assitantType == 'CallOutAbilityCheck' && c.passState == 'Ongoing' && c.exerciseStatus == null && !examCheckBtnTip && !hasExerciseStatus"
                @click="toChildCourse(c.courseId, c.assitantType, c.businessMajorId)">点击测试</div>

              <div class="spb_button" style="background-color: #E1E1E1; color:#ABABAB"
                v-if="c.assitantType == 'CallOutAbilityCheck' && c.passState == 'Ongoing' && c.exerciseStatus == null && examCheckBtnTip && !hasExerciseStatus"
                @click="alertTrainNoStart">
                <!--请于%s-%s在考核群排队参加考核-->
                点击测试
              </div>

              <div class="sph_button"
                v-if="c.assitantType == 'CallOutAbilityCheck' && c.passState == 'Ongoing' && c.exerciseStatus == 1"
                @click="stopKaohePrict">结束测试</div>

              <div class="spb_button"
                v-if="c.assitantType == 'CallOutAbilityCheckRandom' && c.passState == 'Ongoing' && c.exerciseStatus == null && !hasExerciseStatus"
                @click="showRandomScript(c)">点击测试</div>
              <div class="sph_button"
                v-if="c.assitantType == 'CallOutAbilityCheckRandom' && c.passState == 'Ongoing' && c.exerciseStatus == 1"
                @click="stopKaohePrict">结束测试</div>


              <div class="spb_button" v-if="c.assitantType == 'urlLink' && c.unlock == true" @click="goStudy(c)">点击上传</div>

              <div class="spb_button"
                v-if="c.passState == 'Ongoing' && (c.assitantType == '' || c.assitantType == null) && c.courseType != 'Exam'"
                @click="goStudy(c)">点击学习</div>
              <div class="spb_button"
                v-if="c.passState == 'Passed' && (c.assitantType == '' || c.assitantType == null) && c.courseType != 'Exam'"
                @click="goStudy(c)">重新学习</div>
              <div class="spb_button" v-if="c.passState == 'Ongoing' && c.courseType == 'Exam'" @click="goStudy(c)">点击测试
              </div>
              <div class="spb_button" v-if="c.passState == 'Passed' && c.courseType == 'Exam'" @click="goStudy(c)">重新测试
              </div>
              <div class="spb_button"
                v-if="c.passState == null && (c.assitantType == '' || c.assitantType == null) && c.unlock == true"
                @click="goStudy(c)">点击学习</div>
              <!-- 在线--进入售前实操 -->
              <div class="spb_button"
                v-if="c.passState == 'Ongoing' && (c.assitantType == 'beforeSaleExam' || c.assitantType == 'afterSaleExam') && c.unlock == true"
                @click="goStudy(c)">点击学习</div>
              <div class="spb_button"
                v-if="c.passState == 'Passed' && (c.assitantType == 'beforeSaleExam' || c.assitantType == 'afterSaleExam') && c.unlock == true"
                @click="goStudy(c)">重新学习</div>

              <div v-if="c.unlock == false" class="lock"></div>
            </div>
          </div>

          <div>
            <div class="step-list_under" v-if="c.description != ''">
              <div v-html="c.description" style="width:80%"></div>
            </div>
          </div>
          <div v-if="key != 0" class="top_line"
            :class="{ 'top_isCheck': c.passState == 'Passed' || c.passState == 'Ongoing', 'top_noCheck': c.passState == null }">
          </div>
          <div v-if="courseList.length > 1 && key != courseList.length - 1"
            :class="{ line: c.passState == 'Passed', otherline: c.passState == 'Ongoing' || c.passState == null }"></div>
        </div>
        <el-dialog title="" :visible.sync="notification" width="27%" center>
          <div class="isbox">需要先结束考核</div>
          <div class="isbox">是否确定结束考核</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="notification = false">取 消</el-button>
            <el-button type="primary" @click="Clickconfirm">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog :visible.sync="showEachDialog" width="500px">
          <div class="priContent">
            <div class="prictice">
              <div v-if="step == 'second'" class="pricComfir">
                <div class="comTitle"> 请输入对练搭档的9位数淘金号：</div>
                <div class="content">
                  <el-input class="input" v-model="input" placeholder="请输入对练搭档的淘金号"></el-input>
                  <div :class="input ? 'comfirmBtn ActiveComBtn' : 'comfirmBtn'" @click="goToPrict">确定</div>
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
          <span>是否确定与{{ partner.realName }}({{ partner.tjkNumber }})进行语音对练?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="clearSchedule">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="" :visible.sync="exercisePopup" width="27%" center>
          <div class="isbox">需要先结束对练</div>
          <div class="isbox">是否确定结束对练</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="exercisePopup = false">取 消</el-button>
            <el-button type="primary" @click="exerciseClickconfirm">确 定</el-button>
          </span>
        </el-dialog>
      </template>

    </div>

    <el-dialog title="考核次数" :visible.sync="theoryRemainDialog.show" width="360px">
      <el-form>
        <el-form-item label="总考核次数" label-width="150px">
          <el-link type="primary" @click="editRow(scope.row)" :underline="false">{{ theoryRemainDialog.total }}</el-link>
        </el-form-item>
        <el-form-item label="剩余考核数" label-width="150px">
          <el-link type="primary" @click="editRow(scope.row)" :underline="false">{{ theoryRemainDialog.remain }}</el-link>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="currency_button">
          <div class="cancel" @click="theoryRemainDialog.show = false">取消</div>
          <div class="determine" @click="goThoryExamPage">确定</div>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="!!enterGroup.popwin" width="360px" :show-close='false'
      :close-on-click-modal='false'>
      <div class="dialog_img"><img src="@/assets/images/voiceScene/icon_tips.png" alt=""></div>
      <div class="qq_text">{{ enterGroup.popTips }}</div>
      <span slot="footer" class="dialog-footer">
        <div class="currency_button">
          <div class="determine" @click="enterGroupAct">确定</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "SpecialCourses",
  data() {
    return {
      hasExerciseStatus:false,//是否存在[考核课程排班中]
      enterGroup: {
        popwin: null,//
        popwinCourseId: null,
        teamGroupId: null,
        popTips: '',
      },
      courseList: [],//四级列表
      examCheckBtnTip: null,//请于%s-%s在考核群排队参加考核
      sceneId: this.$route.query.sceneId,//场景与课程id
      tjkId: this.$route.query.tjkId,//淘金客id
      trainId: this.$route.query.trainId,//场景id
      assitantType: this.$route.query.assitantType,//场景id
      scriptRelId: this.$route.query.scriptRelId,//淘金大学营销，随机话术脚本id
      step: 'second',
      curLinkCourseId:null,//当前排班,最近点过的 按钮(对外课程/对内课程)
      notification: false,//点击继续练习弹窗
      input: '',
      dialogVisible: false,//确定与对练对象对练弹窗
      istype: '',//保存（判断是否是特殊课程的属性）
      clickStatus: {
        recordId: null,
        clickStatus: "Yes",
        showContinue: null //用于首次 点击练习后，点停止，在不刷新界面的情况下改变按钮显隐
      },
      showEachDialog: false,//对练弹窗
      partner: {},
      exercisePopup: false, //点击点击考核弹窗
      tabIndex: null,//二级tab的index
      kaoheid: null,//考核id
      currentDuilianCourseId: null, //对练courseId
      theoryRemainDialog: {
        show: false,
        courseIdOfsceneId: null,
        passState: null,
        total: null,
        remain: null
      }
    };

  },
  created() {
    if (localStorage.getItem('showEachDialog')) {
      if (localStorage.getItem('showEachDialog') != 0) {
        this.showEachDialog = true;
        localStorage.setItem('showEachDialog', 0)
      }
    }
    this.Lv3Courses()
    this.diaclick()

    //若是从淘金大学随机脚本页面点确定跳过来的，则本业生成一次排班
    if (localStorage.getItem('do_toKaoheDetail') == 'true') {
      localStorage.removeItem('do_toKaoheDetail');
      var businessMajorId = this.$route.query.businessMajorId;
      if (!businessMajorId) {
        this.$message({ message: '淘金大学无关联的考核场景', type: 'warning', center: true, duration: 2500 });
        return;
      }
      this.toKaoheDetail(businessMajorId);
    }
  },
  mounted() {
    // this.isHasPri();
  },
  methods: {
    //语音岗前的
    alertTrainNoStart(){
        this.$message({message: this.examCheckBtnTip, type: 'warning', center: true, duration: 4000});
    },
    diaclick() {
      var divheight = document.getElementsByClassName('step-list')
    },
    // 返回按钮
    isreturn() {
      localStorage.setItem('needSetDefaultTab2', 'false');//返回上级，要求不重新定位
      this.tabIndex = localStorage.getItem('tabIndex')
      this.$router.push({
        path: '/train/index',
        query: {
          tabIndex: this.tabIndex,
          condition: false//判断是否是基础知识点跳课程
        }
      })
    },
    //前往知识点
    goKnowledge(c) {
      this.$router.push({
        path: "/vedioDetail",
        query: {
          courseId: this.courseId,
          knowledgeSeq: c.knowledge.knowledgeSeq
        }
      })
    },
    //三级课程
    Lv3Courses() {
      var self = this;
      this.$http.post(API_ROOT.college + "/majors/queryCourseViewNewXlk", { majorId: this.sceneId, trainId:this.$route.query.trainId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              this.courseList = result.data.data.courseViewList
              self.examCheckBtnTip = result.data.examCheckBtnTip
              this.enterGroup = {
                popwin: result.data.data.popwin,
                popwinCourseId: result.data.data.popwinCourseId,
                teamGroupId: result.data.data.teamGroupId,
                popTips: result.data.data.popwin == 'duilian' ? '接下来进群寻找搭档进行对练' : '接下来进群排队考核',
              }
              for(var i = 0; i < this.courseList.length; i++){
                  if(this.courseList[i].exerciseStatus == 1){
                      this.hasExerciseStatus = true
                      break;
                  }
              }
              if (result.data.data.majorScope == 'Voice') {
                this.isHasPri()
              }
            } else {
              if (result.msg.indexOf('培训已失效，请重新报名下一场培训') > -1) {
                  this.$alert(result.msg, '提示', {
                      showClose:false,
                      confirmButtonText: '确定',
                      callback: action => {
                          this.isreturn()
                      }
                  });

              }
            }
          }, (res) => {
            this.$alert(
              "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
            );
          }
        );
    },
    enterGroupAct() {
      let self = this;
      this.$http.post(API_ROOT.college + "/preWorkTrain/customer/joinVoiceTeamGroup", { trainId: this.trainId, courseId: this.enterGroup.popwinCourseId, groupId: this.enterGroup.teamGroupId })
        .then(
          (res) => {
            var result = res.data;
            if (result.success) {
              const teamGroupId = self.enterGroup.teamGroupId;
              self.enterGroup.popwin = null;
              self.enterGroup.popwinCourseId = null;
              self.enterGroup.teamGroupId = null;
              self.enterGroup.popTips = '';
              this.$http.get(`http://127.0.0.1:26688/api/TjHawkeye/switchMenu?menu=消息&id=${teamGroupId}`).then((res) => { })
            } else {
              this.$alert(result.msg);
            }
          }, (res) => {
            this.$alert(
              "AJAX请求接口异常（/preWorkTrain/customer/joinVoiceTeamGroup）！"
            );
          }
        );
    },
    // 练习记录
    practise(courseId) {
      this.$router.push({ path: '/train/eachExerciseRecordAll',
          query: { trainId: this.trainId, tjkId: this.tjkId, businessMajorId: this.sceneId,courseId:courseId }
      });
    },
    goThoryExamPage() {
      if (this.theoryRemainDialog.remain <= 0) {
        if (this.theoryRemainDialog.passState == 'passed') {
          this.$message({ message: '今日次数已用完，请明日再来', type: 'warning', center: true, duration: 2500 });
        } else {
          this.$message({ message: '考核次数已用完，请报名下一场', type: 'warning', center: true, duration: 2500 });
        }
        return;
      }
      //sceneId=100085&trainId=118&tjkId=8715266
      window.location.href = '/tjkStudy/train/examDetail?courseId=' + this.theoryRemainDialog.courseIdOfsceneId + '&trainFlag=tjcollege&sceneId=' + this.sceneId + '&trainId=' + this.trainId + '&tjkId=' + this.tjkId + '&assitantType=' + this.assitantType;
    },
    // 进入考试
    beginExam(course) {
      //判断是否是 淘金大学营销 考试课程,是就判断一下剩余次数，显示
      var yingxiaoExamCourseId = window.location.href.indexOf('itaojin.cn') > -1 ? 10267 : 10383;
      if (yingxiaoExamCourseId == course.courseId) {
        this.theoryRemainDialog.passState = course.passState;
        this.theoryRemainDialog.courseIdOfsceneId = yingxiaoExamCourseId;
        //如果是 重新测试
        this.$http.post(API_ROOT.college + "/preWorkTrain/customer/queryTheoryRemainTimes", { trainId: this.trainId }).then((res) => {
          var result = res.data;
          if (result.success) {
            this.theoryRemainDialog.total = result.data.total;
            this.theoryRemainDialog.remain = result.data.remain;
            this.theoryRemainDialog.show = true;
          } else {
            this.$alert(result.msg);
          }
        }, (res) => {
          this.$alert("AJAX请求接口异常（/preWorkTrain/customer/queryTheoryRemainTimes）！");
        }
        );
      } else {
        var trainFlag = this.$route.query.trainFlag;
        let Graduation = this.assitantType == 'VoiceGraduateExam';
        if (course.assitantType == 'VoiceGraduateExam') {
          window.location.href = '/tjkStudy/train/examDetail?courseId=' + course.courseId + '&trainFlag=VoiceGraduateExam&sceneId=' + this.sceneId + '&trainId=' + this.trainId + '&tjkId=' + this.tjkId + '&Graduation=' + Graduation + '&assitantType=' + this.assitantType;
        } else if (trainFlag == 'exercise') {//ps: 'theory'不从这儿过，直接从 /train/index进 /train/examDetail
          window.location.href = '/tjkStudy/train/examDetail?trainFlag=exercise&assitantType=OnlineUpgradeSkill&courseId=' + course.courseId + '&sceneId=' + this.sceneId;
        } else {
          window.location.href = '/tjkStudy/train/examDetail?courseId=' + course.courseId + '&trainFlag=' + trainFlag + '&Graduation=' + Graduation + '&assitantType=' + this.assitantType;
        }
      }
    },
    //测试记录
    testRecord(courseId) {
      this.$router.push({ path: '/train/examRecordList', query: { trainId: this.trainId, tjkId: this.tjkId, businessMajorId: this.sceneId,courseId:courseId } });
    },
    //(普通课程)点击学习点击重新学习
    async goStudy(c) {
      var courseId = c.courseId;
      var courseType = c.courseType;
      var assitantType = c.assitantType;
      this.$http.post(API_ROOT.college + "/course/getKnowledgeListXlk", { courseId: courseId }).then((res) => {
        var result = res.data;
        if (result.success) {
          if (result.data.knowledgeRecordFullList.length != 1 && courseType != "Exam") {
            var url = c.assitantJsonObj ? c.assitantJsonObj.url : null;
            this.$router.push({
              path: '/train/Secondarylist',
              query: { courseId: courseId, tjkId: this.tjkId, CourseLevel: 3, sceneId: this.sceneId, trainId: this.trainId, urlLink: url }
            })
          } else if (courseType == "Exam") {
            this.beginExam(c)
            this.examCourseId = courseId;
          } else {
            this.$router.push({
              path: "/vedioDetail",
              query: {
                courseId: courseId,
                knowledgeSeq: result.data.knowledgeRecordFullList[0].knowledgeSeq,
                CourseLevel: 3,
                sceneId: this.sceneId,
                trainId: this.trainId,
                tjkId: this.tjkId,
                knowledgeId: result.data.knowledgeRecordFullList[0].knowledgeId
              }
            });
          }
        } else {
          this.$alert(result.msg);
        }
      }, (res) => {
        this.$alert(
          "AJAX请求接口异常（/assitantTrain/saveWebLoginAndAssitantDown）！"
        );
      }
      );
    },
    isHasPri() {
      this.$http.get(API_ROOT.college + `/voice/exercise/existExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
        if (result.data.success && result.data.data) {
          this.step = 'handing';
          //如果curLinkCourseId为空,则指定:已解锁 + 末尾对练课程(courseList倒着着)
          this.curLinkCourseId = result.data.msg;
          if(this.curLinkCourseId == null || this.curLinkCourseId == 'null'){
            for (let i = this.courseList.length - 1; i >= 0; i--) {
              let c = this.courseList[i];
              if (c.unlock == true && c.assitantType == 'PartnerCallOutExercise') {
                this.curLinkCourseId = c.courseId;
                break;
              }
            }
          }
        } else {
          this.step = 'second';
          //展示开始对练还是继续对练
        }
      });
    },
    //点击点击练习
    goDuilian(type, courseId) {
      this.currentDuilianCourseId = courseId;
      var available = this.checkOperationAvailable(type);
      if (available == 'needEndKaohe') {
        this.notification = true
      } else { this.showEachDialog = true; }
    },
    //点击结束练习
    stopPrict() {
      this.$http.get(API_ROOT.college + `/voice/exercise/endExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
        if (result.data.success) {
          this.step = 'second';
        }
      });
    },
    goLink(c) {
      window.location.href = c.assitantJsonObj.url;
    },

    checkOperationAvailable(ope) {
      //如果点击的是考核，看当前是否是 “结束对练”按钮能点
      if (ope == 'CallOutAbilityCheck') {
        if (this.step == 'handing') {
          return 'needEndDuilian';
        }
      }
      //如果点击的是对练，看当前是否是 “结束考核”按钮能点
      if (ope == 'PartnerCallOutExercise') {
        var needStr = null;
        this.courseList.forEach((a) => {
          if (a.assitantType == 'CallOutAbilityCheck' && a.exerciseStatus == 1) {
            needStr = 'needEndKaohe';
          }
        });
        return needStr;
      }
    },
    // 继续练习弹窗点击确定
    Clickconfirm() {
      localStorage.setItem('showEachDialog', 1)
      this.notification = false
      this.stopKaohePrict()
    },
    goToPrict() {
      var patrn = /^(-)?\d+(\.\d+)?$/;
      if (!patrn.exec(this.input)) {
        this.$message({
          message: '请输入正确的淘金号',
          type: 'error'
        });
        return;
      }
      if (this.input && this.input.length < 9) {
        this.$message({
          message: '淘金号长度至少为9位',
          type: 'error'
        });
        return;
      }

      //查询是否存在当前淘金号
      this.$http.get(API_ROOT.tjkuser + `/tjk/queryTjkList?tjkParam=${this.input}&returnAllData=1`).then((result) => {
        if (result.data.data.length) {
          this.partner = result.data.data[0];
          this.dialogVisible = true;
        } else {
          this.$message({ message: '未找到对应的对练伙伴，请重新输入淘金号', type: 'error' });
        }
      });
      // 打开打卡，然后展示正在练习
    },
    //调用小助手
    getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=').then(response => {
        var result = response.data;
      }, response => {
      })
    },
    ureGoToPri() {
      this.$http.get(API_ROOT.college + `/voice/exercise/ready?tjkId=${this.partner.id}&assitantTjkId=${this.tjkId}&returnAllData=1&courseId=${this.currentDuilianCourseId}`).then((result) => {
        if (result.data.success) {
          this.getHawkeye();
          this.input = '';
          this.step = 'handing';
          this.dialogVisible = false;
          this.showEachDialog = false;
        } else {
          if (result.data.msg && result.data.msg.indexOf('不能有多个语音订单排班') > -1) {
            this.$message({
              message: '请先结束对练 或者结束考核',
              type: 'error'
            });
          } else {
            this.$message({ message: result.data.msg, type: 'error' });
          }
        }
      });
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(res => {
        done();
      }).catch(res => { });
    },
    //清空排版数据
    clearSchedule() {
      this.$http.get('http://127.0.0.1:26688/api/SignIn/clearScheduleCache').then((res) => { })
      this.sureGoToPri();
    },
    stopKaohePrict() {
      var self = this;
      this.$http.get(API_ROOT.college + `/voiceExerciseCustomer/endExamExercise?assitantTjkId=${this.tjkId}&returnAllData=1`).then((result) => {
        if (result.data.success) {
          this.$router.go(0)
        }
      });
    },
    showRandomScript(c) {
      this.$router.push({
        path: "/train/CallOutRandomScript",
        query: {
          courseId: c.courseId,
          assitantType: c.assitantType,
          businessMajorId: c.businessMajorId,
          sceneId: this.sceneId,
          trainId: this.trainId,
          tjkId: this.tjkId
        }
      });
    },
    //--在线进入实操--点击练习，测试
    GoPracticalOperation(type, id, courseId, key, name) {
      this.$router.push({
        path: '/train/OnInline',
        query: {
          page: 'shichao',
          type: type,
          courseId: courseId,
          id: id,
          knowledgeSeq: key + 1,
          key: key + 1,
          courseName: name,
          CourseLevel: 3,
          sceneId: this.sceneId
        }
      })
    },
    //--在线进入实操--点击练习记录
    Gorecord(type, id) {
      this.$router.push({
        path: "/train/OperationRecord", query: { type: type, id: id }
      })
    },

    toChildCourse(courseId, assitantType, businessMajorId) {
      var available = this.checkOperationAvailable(assitantType);
      if (available == 'needEndDuilian') {
        this.istype = assitantType
        this.exercisePopup = true
        this.kaoheid = businessMajorId
      } else {
        if (assitantType == 'PartnerCallOutExercise') {
          //对练
          this.$router.push({
            path: '/train/partnerIndex',
            query: { id: this.sceneId, type: null, tabMajorId: null, show: null }
          });
        } else if (assitantType == 'CallOutAbilityCheck') {
          //考核
          this.toKaoheDetail(businessMajorId, courseId);
        }
      }
    },
    toKaoheDetail(majorId, courseId) {
      this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/examReady', { 'id': majorId, 'trainId': this.trainId ,'courseId':courseId}).then(response => {
        var result = response.data;
        if (result.success) {
          this.Lv3Courses()
          this.toSign(majorId);
        } else {
          this.$alert(result.msg)
          // this.$alert("你考核未合格，请重新报名参加培训");
        }
      }, response => {
        this.$alert('AJAX访问接口异常！');
      })
    },
    toSign(id) {
      this.$http.get('http://127.0.0.1:26789/api/npg/start?id=1').then(response => {
      }, response => { })
    },
    //点击考核弹窗确定
    exerciseClickconfirm() {
      this.stopPrict()
      if (this.istype == 'PartnerCallOutExercise') {
        //对练
        this.$router.push({ path: '/train/partnerIndex', query: { id: this.sceneId, type: this.istype, tabMajorId: this.tabMajorId } });
      } else if (this.istype == 'CallOutAbilityCheck') {
        //考核
        this.toKaoheDetail(this.kaoheid);
      }
      this.exercisePopup = false
    },

    sureGoToPri() {
      this.$http.get(API_ROOT.college + `/voice/exercise/ready?tjkId=${this.partner.id}&assitantTjkId=${this.tjkId}&returnAllData=1&courseId=${this.currentDuilianCourseId}`).then((result) => {
        if (result.data.success) {
          this.$router.go(0)
          this.getHawkeye();
          this.input = '';
          this.step = 'handing';
          this.dialogVisible = false;
          this.showEachDialog = false;
        } else {
          if (result.data.msg && result.data.msg.indexOf('不能有多个语音订单排班') > -1) {
            this.$message({ message: '请先结束对练 或者结束考核', type: 'error' });
          } else {
            this.$message({ message: result.data.msg, type: 'error' });
          }
        }
      });
    },


  }

};
</script>
<style lang='less' scoped>
.isreturn {
  color: #000;
  cursor: pointer;
}

/deep/.el-icon-arrow-left {
  color: #000;
}

.step-list {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 5px;
  padding: 19px 20px 20px 60px;
  position: relative;
}

.step-list_top {
  display: flex;
  justify-content: space-between;
}

.list_top_left {
  display: flex;
}

.list_top_left {
  font-size: 16px;
  color: #262626;
  font-weight: bold;
  position: relative;
  left: -20px;
}

.isred {
  color: #E53434;
  margin-right: 10px;
  font-weight: 600;
  font-size: 12px;
  padding: 0px 3px;
  border: 1px solid #E53434;
  border-radius: 4px;
  margin-left: 9px;
  margin-top: 4px;
  background: #FBE5E5;
  height: 18px;
  line-height: 15px;
}

.isgreen {
  color: #14C034;
  margin-right: 10px;
  font-weight: 600;
  font-size: 12px;
  padding: 0px 3px;
  border: 1px solid #39CA54;
  border-radius: 4px;
  margin-left: 9px;
  margin-top: 4px;
  background: #D9F4DE;
  height: 18px;
  line-height: 15px;
}

/deep/.el-button--small {
  padding: 9px 24px !important;
  border-radius: 6px;
}

/deep/.el-button--primary {
  background-color: #497af2;
}

.step-list_under {
  margin-top: 15px;
  background: #f5f6f7;
  padding: 19px 20px 20px 19px;
  font-size: 13px;
  overflow: hidden;
  color: #262626;
}

.circle {
  width: 20px;
  height: 20px;
  background: #497AF2;
  border-radius: 20px;
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s ease-out;
  left: -20px;
  top: 2px;
  color: #fff;
  font-weight: normal;
  line-height: 20px;
}

.othercircle {
  width: 20px;
  height: 20px;
  background: #BBBBBB;
  border-radius: 20px;
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s ease-out;
  left: -20px;
  top: 2px;
  color: #fff;
  font-weight: normal;
  line-height: 20px;
}

.line {
  width: 2px;

  top: 41px;
  bottom: -20px;
  left: 29px;
  position: absolute;
  border-color: inherit;
  background-color: #1684fc;
  z-index: 99;
}

.otherline {
  width: 2px;

  top: 41px;
  bottom: -20px;
  left: 29px;
  position: absolute;
  border-color: inherit;
  background-color: #BBBBBB;
  z-index: 99;
}

#app {
  height: 100%;
  box-sizing: border-box;
}

#Return_Bar {
  padding-left: 21px;
  display: flex;
  padding-top: 10px;
  padding-bottom: 15px;
  width: 100%;
}

/deep/.el-icon-arrow-left {
  margin-top: 5px;
}

#text {
  background: #f6f5f8;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
}

#text .right {
  width: 100%;
  margin-left: 10px;
}

.right-top {
  display: flex;
  justify-content: space-between;
}

.twolevel_list {
  padding: 10px 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;
  display: flex;
  margin-bottom: 20px;
}

.twolevel_list .left {
  width: 40px;
}

.twolevel_list .left .circle_state {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin-top: 3px;
  margin-left: 10px;
  background: #d5d7d8;
  color: #fff;
  text-align: center;
}

.right_listleft {
  font-size: 17px;
  color: #000;
  font-weight: 600;
}

.right_listleft>.pass {
  margin-left: 10px;
  color: #6cc080;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #6cc080;
  border-radius: 5px;
  background: #d3f6d3;
}

.right_listleft>.failed {
  margin-left: 10px;
  color: #e15062;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 5px;
  border: 1px solid #e15062;
  border-radius: 5px;
  background: #ffe3e2;
}

.right_listright {
  background: #1684fc;
  color: #fff;
  padding: 5px 20px;
  border-radius: 7px;
  cursor: pointer;
}

.right_under {
  background: #f6f5f8;
  padding: 20px;
  margin-top: 10px;
  border-radius: 5px;
  font-size: 13px;
}

.right_under>div {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.circle_state_pass {
  background: #1684fc !important;
}

.lock {
  background: url('../../../assets/images/lock.png') no-repeat center;
  background-size: cover;
  width: 22px;
  height: 22px;
  position: absolute;
  right: 20px;
}

.description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
}

.sp_button {
  width: 95px;
  height: 28px;
  background: #BFD0FB;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #497AF2;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  letter-spacing: 1px;
}

.spb_button {
  width: 95px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  margin-left: 10px;
  letter-spacing: 1px;
}

.sph_button {
  width: 95px;
  height: 28px;
  background: #ff2323;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  margin-left: 10px;
  letter-spacing: 1px;
}

.list_top_right {
  display: flex;
}

.priContent {
  display: flex;
  flex-direction: column;
  align-items: center;

  .prictice {
    .pricComfir {
      width: 100%;
      margin-top: 20px;
      padding-bottom: 50px;
    }

    .comTitle {
      font-weight: 700;
      margin-bottom: 15px;
    }

    .content {
      display: flex;
    }

    .input {
      .el-input__inner {
        border-radius: 10px;
        width: 320px;
      }
    }

    .comfirmBtn {
      margin-left: 15px;
      width: 170px;
      line-height: 40px;
      background-color: #D3D3D3;
      text-align: center;
      color: #fff;
      border-radius: 15px;
    }

    .ActiveComBtn {
      background-color: #118EF2;
      cursor: pointer;
    }

    .stOrNew {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .defaultBtn {
      width: 120px;
      color: #fff;
      border-radius: 20px;
      text-align: center;
      line-height: 35px;
      height: 35px;
      cursor: pointer;
    }

    .newPrict {
      background-color: #008000;
      margin-left: 20px;
    }

    .stopPrict {
      background-color: #FF0000;
    }

    .handBox {
      margin-top: 50px;
    }
  }
}

.top_line {
  position: absolute;
  top: 0;
  left: 29px;
  width: 2px;
  height: 21px;
}

.top_isCheck {
  background: #1684fc;
}

.top_noCheck {
  background: #BBBBBB;
}

/deep/.el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialog_img {
  width: 85px;
  height: 64px;
  margin: 0 auto;
}

/deep/.el-dialog {
  border-radius: 10px;
}

.qq_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #262626;
  line-height: 18px;
  text-align: center;
  margin-top: 14px;
}
</style>
<style>
.currency_button {
  display: flex;
  justify-content: center;
}

.determine {
  width: 80px;
  height: 28px;
  background: #497AF2;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}

.cancel {
  width: 80px;
  height: 28px;
  background: #E1E1E1;
  border-radius: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #717171;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/newservice/SpecialCourses.vue